export default "__VITE_ASSET__P26GKaZc__"